exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoContainer_3JF4F {\n    padding: 0 80px;\n}\n\n.infoContainer_3JF4F > h3 {\n    text-align: center;\n    font-weight: 800;\n}\n\n.infoContainer_3JF4F > h4 {\n    text-align: center;\n    font-weight: 800;\n    text-decoration: underline;\n    font-style: italic;\n}\n\n.descriptionConent_1c1RA {\n    letter-spacing: 0.4px;\n    line-height: 25px;\n}\n\n.descriptionConent_1c1RA > ol > li {\n    padding-bottom: 10px;\n}\n.sectionPoints_6inNw {\n    padding: 40px 10px;\n    font-size: 18px;\n    letter-spacing: 0.4px;\n    line-height: 30px;\n}\n\n.sectionPoints_6inNw > div > ul > li {\n    padding-bottom: 30px;\n}\n\n.gapSection16_hGsly {\n    height: 450px;\n}\n\n.signatureSize_14E9x img {\n    max-width: 200px;\n    max-height: 80px;\n}", ""]);

// exports
exports.locals = {
	"infoContainer": "infoContainer_3JF4F",
	"descriptionConent": "descriptionConent_1c1RA",
	"sectionPoints": "sectionPoints_6inNw",
	"gapSection16": "gapSection16_hGsly",
	"signatureSize": "signatureSize_14E9x"
};